import { createAction } from '@ngrx/store';

enum PaymentCardCompleteActionTypes {
  Init = '[Payment Card Complete] Init',
}

export const init = createAction(PaymentCardCompleteActionTypes.Init);
